<template>
  <planDefault @forbidden="forbidden">
    <template #headerStatistics>
      <statisticsCircle
          class="assessment-plan__expander__statistics-circle"
          :max="assessmentPlan.totalScore"
          v-model="assessmentPlan.score"
      />
    </template>
    <template #default>
      <Alert
        class="mb-4"
        v-if="assessmentPlan.isCompleted"
        type="warning"
      >
        План оценки завершен
      </Alert>
      <testPlanRows>
        <testPlanRow
            v-for="(row, index) in rows"
            :key="index"
            :tests="row.items"
            :title="row.title"
            :loading="isLoading"
            :show_progress="assessmentPlan.show_progress"
        />
      </testPlanRows>
    </template>
  </planDefault>
  <router-view/>
</template>

<script>
import planDefault from '@/components/workspace/assessmentPlans/plans/plan/DefaultPlanSingle.vue';
import testPlanRow from '@/components/workspace/assessmentPlans/plans/plan/test/row/index.vue';
import testPlanRows from '@/components/workspace/assessmentPlans/plans/plan/test/rows/index.vue';
import statisticsCircle from '@/components/workspace/assessmentPlans/plans/statisticsCircle/index.vue';
import {mapGetters, mapState} from 'vuex';
import useToast from "@/components/UI/AppToast/useToast.js";
import Alert from '@/components/UI/AppAlert/AppAlert.vue';
import router from "@/router/index.js";
import store from "@/store/index.js";

export default {
  name: 'planRespondent',
  computed: {
    ...mapGetters('assessmentPlans/plan', ['rows']),
    ...mapState('assessmentPlans/plan', ['assessmentPlan', 'isLoading']),
  },
  components: { Alert, testPlanRows, testPlanRow, planDefault, statisticsCircle},
  watch: {
    assessmentPlan() {
      const {toast} = useToast()
      if (!this.assessmentPlan.uuid && !this.assessmentPlan.isCompleted) {
        toast.error('План оценки не найден')
        this.$router.push({name: 'AssessmentPlansList'})
      } else {
        if (this.assessmentPlan.isCompleted) {
          toast.error('План оценки остановлен')
          this.$router.push({name: 'AssessmentPlansList'})
        }else if (this.assessmentPlan.allFieldsAreFilled === false) {
          toast.error('Необходимо заполнить поля анкеты для плана')
          this.$router.push({
            name: 'UserCabinet',
            query: {
              'plannofilled': this.assessmentPlan.uuid,
            },
          })
        }
      }
    }
  },
  methods:{
    forbidden:function(){
      const {toast} = useToast()
      toast.error('План оценки заблокирован')
      this.$router.push({name: 'AssessmentPlansList'})
    }
  }
}
</script>

<style lang="scss">
.assessment-plan {
  &__expander {
    &__statistics-circle {
      min-width: 148px;
      margin: 7.5px;
    }
  }

  @media all and (max-width: 767px) {
    .mt-data-table {
      &__header {
        padding: 0 10px;

        > button {
          width: fit-content;
          height: fit-content;
          background-color: transparent;
        }
      }
    }
  }
}
</style>